/*
 * Copyright (c) 2018 Infowijs.
 * Created by Thomas Schoffelen.
 */

$('body').click(function (event) {
  const $schoolSelector = $('.school-selector')

  if (event.target.className === 'school-selector-label' || $(event.target).parents('.school-selector-label').length) {
    $schoolSelector.toggleClass('open')
    if (window.mobileMenuVisible) {
      toggleMobileNav()
    }
    return
  }
  $schoolSelector.removeClass('open')
})
